// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_loading__r02Qn {
  align-items: center;
  display: flex;
  height: 80vh;
  justify-content: center;
  width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/Solicitacoes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".loading {\n  align-items: center;\n  display: flex;\n  height: 80vh;\n  justify-content: center;\n  width: 100vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `styles_loading__r02Qn`
};
export default ___CSS_LOADER_EXPORT___;
